export const selectCurrentuser = (state) => state.user.currentUser;